import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {interval, Subscription, switchMap} from 'rxjs';
import {APP_CONFIG} from '../../../app.config';
import {AuthService, ParserService} from '@gallaghercp/core-frontend';
import {ClientService} from '../../../services/client.service';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {RecaptchaComponent} from 'ng-recaptcha';
import {take, tap} from 'rxjs/operators';

@Component({
    selector: 'core-login',
    templateUrl: './login.component.html',
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
    @ViewChild('captchaRef') recaptchaRef!: RecaptchaComponent;
    @ViewChild('accessCode') accessCodeInput!: ElementRef;

    currentYear: number = new Date().getFullYear();

    loading!: boolean;
    errorMessage!: string | boolean;
    successMessage!: string | boolean;

    subscription: Subscription = new Subscription();
    private ssoCount: number = 0;
    private checkInterval?: Subscription;
    private ssoWindow?: Window;

    loginForm = new FormGroup({
        accessCode: new FormControl('', [
            Validators.required,
            Validators.minLength(32),
            Validators.maxLength(32)
        ])
    });

    copyright = APP_CONFIG.copyright;

    constructor(
        public client: ClientService,
        protected auth: AuthService,
        protected parser: ParserService,
        protected router: Router,
        protected titleService: Title
    ) {
    }

    ngOnInit() {
        this.titleService.setTitle('Login | ' + APP_CONFIG.appName);
        this.auth.validateAuthentication().subscribe(() => {
            if (this.auth.isAuthenticated()) {
                this.router.navigate(['/']);
            }
        });
        this.subscription.add(
            this.auth.validateAuthentication().subscribe(() => {
                if (this.auth.isAuthenticated()) {
                    this.router.navigate(['/']);
                }
            })
        );
    }

    openSSO(): void {
        this.ssoWindow = (window.open("/sso", "SOLV SSO", "width=500,height=500,top=0") as Window);
        this.startSSOCheck();
    }


    startSSOCheck() {
        this.checkInterval = interval(1500).pipe(
            switchMap(() => {
                if (this.parser.getCookie('x-service-user-name') || this.parser.getCookie('x-service-emulated-user-name')) {
                    return this.auth.isResumed.pipe(
                        take(1),
                        tap(isAuthenticated => {
                            if (isAuthenticated) {
                                this.handleAuthenticatedUser();
                            }
                        })
                    );
                } else {
                    return [];
                }
            }),
            tap(() => {
                if (this.ssoCount++ >= 90) {
                    this.checkInterval!.unsubscribe();
                }
            })
        ).subscribe();
    }

    handleAuthenticatedUser() {
        this.checkInterval!.unsubscribe();
        if (this.ssoWindow) {
            this.ssoWindow.close();
        }
        this.auth.resume();
        this.router.navigate([this.auth.redirectUrl]);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.checkInterval?.unsubscribe();
    }

}
